// removed by extract-text-webpack-plugin
module.exports = {"masonry":"src-components-TestimonialGrid-__TestimonialGrid-module___masonry","masonry_column":"src-components-TestimonialGrid-__TestimonialGrid-module___masonry_column","masonry_tile":"src-components-TestimonialGrid-__TestimonialGrid-module___masonry_tile"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TestimonialGrid/TestimonialGrid.module.css
// module id = 388
// module chunks = 0